import { useTranslation } from 'react-i18next';
import { formatCurrency } from '~/utils';

type PackingListTotalsProps = Readonly<{
  originalTotal: number;
  packedTotal: number;
  variance: number;
  currency?: string;
}>;

export function PackingListTotals({
  originalTotal,
  packedTotal,
  variance,
  currency,
}: PackingListTotalsProps) {
  const { t } = useTranslation('order');
  return (
    <div className="p-4 border-t border-gray-100 grid grid-cols-3 gap-3">
      <div className="rounded-xl border border-gray-200 bg-white p-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
          {t('order.packing_list.original_total')}
        </p>
        <p className="mt-1 text-lg font-semibold text-gray-900">
          {formatCurrency(originalTotal, currency)}
        </p>
      </div>
      <div className="rounded-xl border border-gray-200 bg-white p-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
          {t('order.packing_list.packed_total')}
        </p>
        <p className="mt-1 text-lg font-semibold text-gray-900">
          {formatCurrency(packedTotal, currency)}
        </p>
      </div>
      <div className="rounded-xl border border-gray-200 bg-white p-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
          {t('order.packing_list.variance')}
        </p>
        <p
          className={`mt-1 text-lg font-semibold ${
            Math.abs(variance) < 0.01
              ? 'text-gray-900'
              : variance > 0
                ? 'text-amber-600'
                : 'text-green-600'
          }`}
        >
          {variance >= 0 ? '' : '-'}
          {formatCurrency(Math.abs(variance), currency)}
        </p>
      </div>
    </div>
  );
}
